import { render, staticRenderFns } from "./RunOrNotificationCard.vue?vue&type=template&id=2f2bf54c&"
import script from "./RunOrNotificationCard.vue?vue&type=script&lang=ts&"
export * from "./RunOrNotificationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports